import { connect } from 'react-redux'
import FormatSelector from './FormatSelector'
import { changeExportFormat } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	format: state.exportSettings.format
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: (event) => dispatch(changeExportFormat(event.target.value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormatSelector)



// WEBPACK FOOTER //
// ./src/components/Export/FormatSelectorContainer.js